var isUserAuthenticated = function () {
    var _a, _b;
    if (typeof window === 'undefined')
        return false;
    return !!((_a = window === null || window === void 0 ? void 0 : window.PORTAL) === null || _a === void 0 ? void 0 : _a.user) || ((_b = window === null || window === void 0 ? void 0 : window.user) === null || _b === void 0 ? void 0 : _b.isAuthenticated);
};

export { isUserAuthenticated };
//# sourceMappingURL=isUserAuthenticated.esm.js.map
